

































































































import { Component, Vue } from 'vue-property-decorator';
import { getCalendarUuid, CalendarResponse } from '@/webservices/calendar';

@Component({
    name: 'Calendar',
})
export default class Calendar extends Vue {
    private calendarData: CalendarResponse | null = null;
    private loading = true;
    private error: string | null = null;
    private isCopied = false;

    get currentLanguage() {
        return this.$i18n.locale || 'de';
    }

    get copyText() {
        return this.isCopied ? this.$t('keywords.copied').toString() : this.$t('keywords.copy').toString();
    }

    async created() {
        try {
            this.calendarData = await getCalendarUuid();
        } catch (e) {
            this.error = this.$t('errors.server.failedToLoadCalendar').toString();
        } finally {
            this.loading = false;
        }
    }

    private copyToClipboard(text: string) {
        this.$copyText(text).then(
            () => {
                this.isCopied = true;
                setTimeout(() => {
                    this.isCopied = false;
                }, 2000);
            },
            (e) => {
                console.error('Could not copy text: ', e);
            }
        );
    }
}
